<template>
  <div class="main-content">

    <!-- Breadcrumb -->
    <p class="mb-1 text-muted" style="font-size: 12px">
      <router-link to="/assuntos" class="text-muted">Assuntos</router-link>
      <span v-if="documento.assunto">
        /
        <router-link
          :to="'/documentos?assunto_id=' + documento.assunto_id"
          class="text-muted"
        >{{ documento.assunto.nome }}</router-link>
      </span>
      / {{ documento.titulo }}
    </p>

    <!-- Cabeçalho -->
    <div class="mb-3">
      <h3 class="mb-0 font-weight-bold">{{ documento.titulo }}</h3>
    </div>

    <!-- Card do arquivo -->
    <div class="card card-shadow mb-3" v-if="documento.arquivo">
      <div class="card-body d-flex align-items-center">
        <i
          :class="'fa ' + iconeArquivo"
          style="font-size: 40px; min-width: 50px"
        ></i>
        <div class="ml-3 flex-grow-1">
          <p class="mb-0 font-weight-bold">{{ documento.nome_original }}</p>
          <small class="text-muted">{{ (documento.extensao || '').toUpperCase() }}</small>
        </div>
        <a :href="arquivoUrl" target="_blank" class="btn btn-primary ml-3">
          <i class="fa fa-external-link mr-1"></i> Abrir documento
        </a>
      </div>
    </div>

    <div class="card card-shadow mb-3" v-else>
      <div class="card-body text-center text-muted py-3">
        <i class="fa fa-file-o fa-2x mb-2"></i>
        <p class="mb-0">Nenhum arquivo anexado.</p>
      </div>
    </div>

    <!-- Descrição -->
    <div class="card card-shadow mb-3" v-if="documento.descricao">
      <div class="card-header">
        <h5 class="mb-0">Descrição</h5>
      </div>
      <div class="card-body ck-content" v-html="documento.descricao"></div>
    </div>

    <!-- Botão Voltar -->
    <div class="text-right mt-2">
      <router-link
        :to="'/documentos?assunto_id=' + documento.assunto_id"
        class="btn btn-back"
      >
        <i class="fa fa-arrow-left mr-1"></i> Voltar
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      documento: {
        titulo: "",
        descricao: "",
        arquivo: null,
        nome_original: null,
        extensao: null,
        assunto_id: null,
        assunto: null,
      },
    };
  },
  computed: {
    arquivoUrl() {
      return (
        this.$store.state.api +
        "documentos/" +
        this.$route.params.id +
        "/visualizar"
      );
    },
    iconeArquivo() {
      const icones = {
        pdf:  "fas fa-file-pdf text-danger",
        xlsx: "fas fa-file-excel text-success",
        xls:  "fas fa-file-excel text-success",
        docx: "fas fa-file-word text-primary",
        doc:  "fas fa-file-word text-primary",
        pptx: "fas fa-file-powerpoint text-warning",
        ppt:  "fas fa-file-powerpoint text-warning",
        jpg:  "fas fa-file-image text-info",
        jpeg: "fas fa-file-image text-info",
        png:  "fas fa-file-image text-info",
        gif:  "fas fa-file-image text-info",
        bmp:  "fas fa-file-image text-info",
        webp: "fas fa-file-image text-info",
      };
      return (
        icones[(this.documento.extensao || "").toLowerCase()] ||
        "fas fa-file text-secondary"
      );
    },
  },
  methods: {
    getDocumento(id) {
      const self = this;
      self.$loading(true);
      axios
        .get(self.$store.state.api + "documentos/" + id + "?with[]=assunto")
        .then((response) => {
          self.documento = response.data.data[0];
          self.$loading(false);
        })
        .catch(() => {
          self.$loading(false);
          self.$message("Erro", "Documento não encontrado.", "error");
          self.$router.go(-1);
        });
    },
  },
  mounted() {
    this.getDocumento(this.$route.params.id);
  },
};
</script>

<style scoped>
.card-shadow {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.card-shadow:hover {
  transform: scale(1.002);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.32);
}

.ck-content :deep(h2),
.ck-content :deep(h3),
.ck-content :deep(h4) {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
.ck-content :deep(ul),
.ck-content :deep(ol) {
  padding-left: 1.5rem;
}
.ck-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
}
.ck-content :deep(td),
.ck-content :deep(th) {
  border: 1px solid #dee2e6;
  padding: 0.5rem;
}
</style>
